































































































import Vue from 'vue';
import { Users } from 'mycorems-app-accounts';
import { PaymentsTable, PaymentMethods } from 'mycorems-app-billing';
import isGranted from '@/auth/isGranted';
import FetchEmailCampaignsBtn from '@/email-campaign/FetchEmailCampaignsBtn.vue';
import EmailCampaignsTable from '@/email-campaign/EmailCampaignsTable.vue';
import ClientSummary from '@/account/client/ClientSummary.vue';
import EmailReportTab from '@/email-campaign/report/EmailReportTab.vue';
import AccountSettings from '@/account-settings/AccountSettings.vue';
import ListCustomFieldsTable from '@/account/client/ListCustomFieldsTable.vue';

interface Data {
  viewableEmailCampaignId: string|null,
}

export default Vue.extend({
  props: {
    companyId: {
      type: String,
      required: true,
    },
    tab: {
      type: String,
      default: 'campaigns',
    },
    reportId: String,
  },
  data(): Data {
    return {
      viewableEmailCampaignId: null,
    };
  },
  watch: {
    companyId: {
      handler(): void {
        this.clearViewableReport();
      },
      immediate: true,
    },
  },
  methods: {
    tabRoute(tab?: string): object {
      return {
        name: 'company_dashboard',
        params: {
          companyId: this.companyId,
          tab,
        },
      };
    },
    reportTabRoute(): object {
      return {
        name: 'company_dashboard',
        params: {
          companyId: this.companyId,
          tab: 'report',
          reportId: this.viewableEmailCampaignId,
        },
      };
    },
    clearViewableReport(): void {
      this.viewableEmailCampaignId = null;
    },
    viewReport(emailCampaignId: string): void {
      this.viewableEmailCampaignId = emailCampaignId;
      this.$router.push(this.reportTabRoute());
    },
    isGranted,
  },
  components: {
    FetchEmailCampaignsBtn,
    EmailCampaignsTable,
    ClientSummary,
    EmailReportTab,
    Users,
    PaymentsTable,
    PaymentMethods,
    AccountSettings,
    ListCustomFieldsTable,
  },
});
